import { useCallback, useEffect } from "react";

// Client
import IncidentClient from "@common/api/IncidentClient";

// Actions
import useLogin from "@common/components/hooks/useLogin";
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";
import { parseCustomerIncidentResponse } from "../helpers/compliance";

// Helpers
import fetchIncidentData from "@common/components/helpers/CustomerIncident/fetchIncidentData";
import prepareIncidentData from "@common/components/helpers/CustomerIncident/prepareIncidentData";
import useCustomer from "./useCustomer";
import useCompliance from "./useCompliance";

const useCustomerIncidentForm = ({ formData, siteGuid, form }) => {
  const { watch, setValue } = form;
  const watchCustomerIncidentType = watch("customerIncidentType");

  const [{ isDesktop }] = useLogin();
  const { onNewCustomer, onSelectCustomer, onEditCustomer, onRemoveCustomer } =
    useCustomer();
  const setCustomerFormState = (data) => CustomerFormAction.dispatch(data);

  const { resetComplianceForms, submitComplianceForm } = useCompliance();

  useEffect(() => {
    if (watchCustomerIncidentType && watchCustomerIncidentType.policeIncident) {
      setValue("esCalled", true, { shouldValidate: true });
    }
  }, [watchCustomerIncidentType, formData.customerIncidentTypes, setValue]);

  const handleFormLoad = useCallback(() => {
    fetchIncidentData(siteGuid);
  }, [siteGuid]);

  useEffect(() => {
    handleFormLoad();
  }, [handleFormLoad]);

  useEffect(() => {
    setCustomerFormState({ formType: "customerIncident" });
  }, []);

  const resetForm = (redirect) => {
    resetComplianceForms(redirect);
    handleFormLoad();
  };

  const onSubmit = (data) => {
    const payload = prepareIncidentData(data, formData, siteGuid);

    submitComplianceForm({
      client: IncidentClient,
      payload,
      resetForm,
      desktopCallback: (response) =>
        form.reset(parseCustomerIncidentResponse(response)),
    });
  };

  const onError = (errors) => console.error("Submit errors ", errors);

  const onSelect = (customerId) => onSelectCustomer(customerId);

  const handleNewCustomer = (customer) => onNewCustomer(customer);

  const handleEditCustomer = (customer) => onEditCustomer(customer);

  const handleRemoveCustomer = (customer) => onRemoveCustomer(customer);

  const handleExistingCustomer = () => {};

  return {
    onSubmit,
    onError,
    resetForm,
    isDesktop,
    onSelect,
    handleNewCustomer,
    handleEditCustomer,
    handleRemoveCustomer,
    handleExistingCustomer,
  };
};

export default useCustomerIncidentForm;
